import React from 'react';
import PropTypes from 'prop-types';
import { PiArrowRight, PiRepeat, PiPencilSimple } from 'react-icons/pi';
import BottomSheet from '../BottomSheet';
import { haptics } from '../../utils/haptics';
import './styles.css';

const RecurringEditScopeSheet = ({ onClose, onEditOnlyThis, onEditThisAndFollowing, loading = false }) => (
  <BottomSheet
    title="Editar movimentação recorrente"
    onClose={loading ? () => {} : onClose}
    size="md"
    footer={(
      <button type="button" className="nf-sheet__secondary" onClick={onClose} disabled={loading}>
        Cancelar
      </button>
    )}
  >
    <div className="recurring-edit-scope">
      <p>Esta movimentação faz parte de uma recorrência. O que você deseja alterar?</p>

      <button
        type="button"
        className="recurring-edit-scope__option recurring-edit-scope__option--active"
        onClick={() => { void haptics.selection(); onEditOnlyThis(); }}
        disabled={loading}
      >
        <span className="recurring-edit-scope__icon" aria-hidden="true"><PiPencilSimple /></span>
        <span><strong>Somente esta ocorrência</strong><small>Alterar apenas esta movimentação.</small></span>
        {loading ? <span className="recurring-edit-scope__loading" role="status">Preparando…</span> : <PiArrowRight aria-hidden="true" />}
      </button>

      <button
        type="button"
        className="recurring-edit-scope__option recurring-edit-scope__option--active"
        onClick={() => { void haptics.selection(); onEditThisAndFollowing(); }}
        disabled={loading}
      >
        <span className="recurring-edit-scope__icon" aria-hidden="true"><PiRepeat /></span>
        <span><strong>Esta e as próximas</strong><small>Alterar esta e as próximas ocorrências.</small></span>
        <PiArrowRight aria-hidden="true" />
      </button>

    </div>
  </BottomSheet>
);

RecurringEditScopeSheet.propTypes = {
  onClose: PropTypes.func.isRequired,
  onEditOnlyThis: PropTypes.func.isRequired,
  onEditThisAndFollowing: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default RecurringEditScopeSheet;

